import { useParams } from 'react-router-dom';
import { useEntityUrl } from 'framework/routing';

export const QM_PATH = '/qualification-models';

const SPECIALIZATION_ID_SOURCE = 'specializationId';

export const useQualificationModelUrl = () => useEntityUrl({ baseLink: QM_PATH, idSource: 'version' });

export const useSingleQualificationModelUrl = () => {
  const { getSingleEntityUrl } = useQualificationModelUrl();

  return useEntityUrl({ baseLink: getSingleEntityUrl(), idSource: SPECIALIZATION_ID_SOURCE });
};

export const useSpecializationId = () => useParams<Dictionary<string>>()[SPECIALIZATION_ID_SOURCE];
